// extracted by mini-css-extract-plugin
module.exports = {"orderContainer":"orderContainer--ZMCKw","footerBox":"footerBox--5fzyF","btns":"btns--KBUqE"};